import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import { connect } from 'react-redux';

import LegacyBreadcrumb from '../../../legacy/breadcrumb';

class CampaignBreadcrumb extends PureComponent {
  getBreadcrumbPath() {
    const { base } = this.props;

    const path = [
      {
        id: 'campaigns',
        name: this.context.t('campaigns', 'themes.breadcrumb'),
        pathName: base,
      },
    ];
    if (this.props.campaign) {
      path.push({
        id: `${this.props.campaign.id}`,
        name: this.props.campaign.name,
        pathName: `${base}/${this.props.campaign.slug}`,
      });
      if (this.props.article) {
        path.push({
          id: `${this.props.article.id}`,
          name: this.props.article.title,
          pathName: this.props.article.pathName,
        });
      }
    }
    return path;
  }

  render() {
    const { t, renderMode } = this.context;
    const legacyMode = ['mobile', 'desktop'].includes(renderMode);
    return legacyMode ? (
      <LegacyBreadcrumb
        homeText={t('common', 'breadcrumb.home')}
        path={this.getBreadcrumbPath()}
      />
    ) : (
      <Breadcrumb
        homeText={t('common', 'breadcrumb.home')}
        path={this.getBreadcrumbPath()}
      />
    );
  }
}

const { string, shape } = PropTypes;

CampaignBreadcrumb.propTypes = {
  article: shape({
    slug: string,
    title: string,
  }),
  campaign: shape({
    slug: string,
    title: shape({
      short: string,
    }),
  }),
  base: string.isRequired,
};

CampaignBreadcrumb.defaultProps = {
  article: undefined,
  campaign: undefined,
};

CampaignBreadcrumb.contextType = AppContext;

export default connect(state => ({
  base: state.areas.campaign.base,
}))(CampaignBreadcrumb);
